<template>
    <div class="lg:grid grid-cols-12 lg:gap-5 gap-3 articles">
        <div class="col-span-9">
            <h4>Todo el contenido</h4>
            <div class="mt-8">
                <article-item
                    v-for="(article, index) in displayedArticles"
                    :article="article"
                    :user="user"
                    :key="index"
                >
                </article-item>
            </div>
        </div>
        <!-- Sidebar -->
        <div class="col-span-3 lg:mt-0 mt-8 lg:-mr-3">
            <div
                class="lg:sticky lg:top-12 pb-8 hxl:h-screen-xl hlg:h-screen-lg hmd:h-screen-md overflow-y-auto overflow-x-hidden simplebar-custom-vertical"
                data-simplebar
            >
                <div class="sm:grid grid-cols-1 gap-6">
                    <category-filter
                        v-model="activeCategory"
                        :categories="categories"
                        @input="load()"
                    ></category-filter>
                    <!-- Tags -->
                    <div class="col-span-1 xl:mt-12 sm:mt-0 mt-6">
                        <h4>Tags más populares</h4>
                        <div class="mt-6">
                            <a
                                v-for="(tag, index) in tags"
                                :href="`/revista/tags/${tag.slug}`"
                                :key="index"
                                class="inline-block px-4 py-1 my-2 mr-3 text-sm text-gray-400 transition duration-300 ease-in-out bg-gray-200 rounded-full outline-none hover:text-gray-600 capitalize"
                            >
                                {{ tag.name }}
                            </a>
                        </div>
                        <a
                            href="#"
                            class="block text-red-500 hover:text-red-700 transition duration-300 ease-in-out mt-3"
                        >
                            Buscar más &#62;
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <load-more container=".articles" @ready="loadMore()"></load-more>
    </div>
</template>

<script>
import ArticleItem from './ArticleItem';
import CategoryFilter from './CategoryFilter';
import LoadMore from './LoadMore';

export default {
    props: {
        categories: {
            type: Array,
            required: true,
        },
        tags: {
            type: Array,
            required: true,
        },
        user: {
            type: Object,
            required: false,
        },
    },

    components: {
        ArticleItem,
        CategoryFilter,
        LoadMore,
    },

    mounted() {
        this.fetchArticles();
    },

    data() {
        return {
            activeCategory: '',
            activeArticles: {},
            isPaginated: false,
            perPage: 12,
        };
    },

    methods: {
        async fetchArticles() {
            const category = this.selectedCategory();

            let response = await axios.get(`/api/articles?category=${category}`);
            response.data.links.next ? (this.isPaginated = true) : (this.isPaginated = false);

            this.activeArticles = response.data.data;
            this.activeCategory = category;
        },

        loadMore() {
            if (this.isPaginated) {
                this.load();
            }
        },

        pushArticles(received) {
            return (this.activeArticles = this.activeArticles.concat(received));
        },

        load() {
            axios.get('/api/articles?page=' + this.page + '&category=' + this.activeCategory).then((response) => {
                this.activeArticles = this.activeArticles.concat(
                    response.data.data.filter((element) =>
                        this.activeArticles.every((displayed) => displayed.slug !== element.slug)
                    )
                );
                response.data.links.next ? (this.isPaginated = true) : (this.isPaginated = false);
            });
        },

        selectedCategory() {
            let queryString = window.location.search;
            let url = new URLSearchParams(queryString);

            return url.has('category') ? url.get('category') : '';
        },
    },

    computed: {
        displayedArticles() {
            if (!this.activeCategory) {
                return this.activeArticles;
            }

            return this.activeArticles.filter((article) => article.category_slug === this.activeCategory);
        },
        page() {
            return Math.floor(this.displayedArticles.length / this.perPage) + 1;
        },
    },
};
</script>
